import React from 'react';
import PropTypes from 'prop-types';
import {Colours} from '@learningblocks/storybook-components';
import './style.scss';

export function Tube(props) {
  const tubeShapes = [
    <path
      key='1'
      fill='#868CA6'
      d='M17.717 109.713c-1.139 0-2.878-.418-3.838-.717s-1.739-3.762-1.739-3.762c-2.518-9.795-5.928-24.207-6.005-32.895-.016-1.722 0-35.161 0-35.161H29.276v35.16c0 8.974-4.003 23.1-6.521 32.896 0 0-.78 3.463-1.74 3.762-.959.299-2.698.717-3.837.717'
    />,
    <path
      key='2'
      fill='#C0C3D2'
      d='M17.648 108.509c-1.02 0-2.579-.359-3.418-.657-.84-.239-1.56-3.404-1.56-3.404-2.278-8.78-4.59-21.723-5.25-29.428V39.007h20.571s.36 31.952 0 36.013c-.66 7.705-3.506 20.588-5.785 29.368 0 0-.72 3.105-1.56 3.404-.839.239-2.398.657-3.418.657'
      opacity='.7'
    />,
    <path key='3' fill='#868CA6' d='M3.563 37.178H33.133V39.742H3.563z' />,
    <path
      key='4'
      fill='#000'
      fillOpacity='.1'
      d='M22.849 39.741h6.428v33.984c0 3.776-2.571 15.734-2.571 15.734s-4.862 18.604-5.143 18.88c-.281.275-3.857.629-3.857.629l5.143-35.243V39.741z'
    />,
    <path
      key='5'
      fill='#577898'
      d='M7.421 35.895H27.991V37.17700000000001H7.421z'
    />,
    <path key='6' fill='#868CA6' d='M0.992 33.331H34.419V35.895H0.992z' />,
    <path
      key='7'
      fill='#868CA6'
      fillRule='evenodd'
      d='M37.855 34.77c.322.542.42 1.158.42 1.766 0 .608-.099 1.224-.42 1.765-.34.573-.843.918-1.378 1.118-.5.187-1.053.257-1.577.29-.522.032-1.118.032-1.738.032h-.03v-2.564c.656 0 1.174 0 1.608-.028.441-.027.692-.078.834-.13.031-.012.052-.022.065-.03l.008-.004.005-.011c.005-.015.013-.04.021-.076.017-.074.031-.19.031-.362s-.014-.288-.03-.362c-.009-.036-.017-.06-.022-.075l-.005-.012-.008-.005c-.013-.007-.034-.017-.065-.028-.142-.053-.393-.104-.834-.131-.434-.028-.952-.028-1.607-.028v-2.564h.029c.62 0 1.216 0 1.738.033.523.032 1.076.102 1.577.289.535.2 1.038.545 1.378 1.118z'
      clipRule='evenodd'
    />,
    props.solutionColor ? (
      <path
        key='8'
        fill={props.solutionColor}
        d='M17.648 108.509c-1.02 0-2.579-.359-3.418-.657-.84-.239-1.56-3.405-1.56-3.405-2.278-8.78-4.59-21.722-5.25-29.427V70.51H27.992v4.511c-.66 7.705-3.506 20.588-5.785 29.368 0 0-.72 3.105-1.56 3.404-.839.239-2.398.657-3.418.657'
        opacity='.7'
      />
    ) : null,
    props.label || props.circleColorLabel ? (
      <path
        key='9'
        fill={props.bannerColor}
        d='M6.136 47.98H29.278V68.49199999999999H6.136z'
      />
    ) : null,
    props.overlapCircleColor ? (
      <circle
        key='10'
        cx='18'
        cy='57.5'
        r='7.5'
        fill={props.overlapCircleColor}
      />
    ) : null,
    props.circleColorLabel ? (
      <circle
        key='11'
        cx='18'
        cy='57.5'
        r='6.5'
        fill={props.circleColorLabel}
      />
    ) : null,
    props.label ? (
      <text
        key='12'
        x='10'
        y='60'
        z='1000'
        fill='#000'
        fontSize='small'
        alignmentBaseline='middle'
        className='tubeSVG__label'>
        {props.label}
      </text>
    ) : null,
  ];

  const renderShape = (shape) => shape;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={props.width}
      height={props.height}
      fill='none'
      className='tubeSVG'
      viewBox='0 33 40 78'>
      {tubeShapes.map(renderShape)}
    </svg>
  );
}

Tube.propTypes = {
  /**
   * label for solution
   */
  label: PropTypes.string,
  /**
   * Color value for the color label [ displayed in circular dot ]
   */
  circleColorLabel: PropTypes.string,
  /**
   * Color to assign as the border of the circleColorLabel
   */
  overlapCircleColor: PropTypes.string,
  /**
   * Color of the solution
   */
  solutionColor: PropTypes.string,
  /**
   * width for the svg image
   */
  width: PropTypes.number,
  /**
   * Height for the svg image
   */
  height: PropTypes.number,
};

Tube.defaultProps = {
  solutionColor: Colours.colorSecondaryCyan,
  bannerColor: Colours.colorNeutralWhite,
  circleColorLabel: '',
  overlapCircleColor: '',
  label: '',
  width: 51,
  height: 90,
};
